module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./chunks/runtime/a.js
 ** module id = 8
 ** module chunks = 4 5
 **/